var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLeaved
    ? _c("div", { staticClass: "modal-cover", on: { click: _vm.onClose } }, [
        _c(
          "div",
          {
            staticClass: "attendance-container",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "attendance-header-container" }, [
              _c("button", {
                staticClass: "close-modal",
                on: { click: _vm.onClose },
              }),
              _c("div", [_vm._v(_vm._s(_vm.$t("camstudy.attendance.title")))]),
              _c(
                "div",
                {
                  staticClass: "attendance-expand-container",
                  on: { click: _vm.selectAll },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "attendance-expand",
                      class: { open: _vm.expandAll },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.expandAll
                              ? _vm.$t("camstudy.attendance.closeAll")
                              : _vm.$t("camstudy.attendance.expandAll")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _c(
              "ul",
              { staticClass: "attendance-body-container" },
              _vm._l(_vm.attendanceUserList, function (cu) {
                return _c(
                  "li",
                  {
                    key: `attendance-` + cu.userId,
                    staticClass: "attendance-user-item",
                    on: {
                      click: function ($event) {
                        return _vm.onSelectUser(cu)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "attendance-item-container" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "attendance-list-item flex justify-between items-center w-full",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex overflow-hidden mr-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "v-name-img" },
                                [
                                  _c("UserProfileImage", {
                                    staticClass: "profile-image",
                                    attrs: { "user-id": cu.userId },
                                  }),
                                  _vm.hasEmceeRole(cu.userId)
                                    ? _c("GrmIcon", {
                                        class: _vm.hasSpeakerRole(cu.userId)
                                          ? "room-speaker"
                                          : "room-emcee",
                                        attrs: { icon: "" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "user-name" }, [
                                _vm._v(_vm._s(cu.username)),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex gap-2 items-center flex-shrink-0",
                            },
                            [
                              _vm.camStudy?.usePoint
                                ? [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("camstudy.attendance.score")
                                        )
                                      ),
                                    ]),
                                    _vm.selected(cu.userId) &&
                                    _vm.hasEmceeRole()
                                      ? _c("button", {
                                          staticClass: "minus-score",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.addPoint(
                                                cu.userId,
                                                -1,
                                                cu.point + cu.pPoint
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _c("div", [
                                      _vm._v(_vm._s(cu.point + cu.pPoint)),
                                    ]),
                                    _vm.selected(cu.userId) &&
                                    _vm.hasEmceeRole()
                                      ? _c("button", {
                                          staticClass: "plus-score",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.addPoint(
                                                cu.userId,
                                                1,
                                                cu.point + cu.pPoint
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              _c(
                                "button",
                                {
                                  staticClass: "attendance-list-item-btn",
                                  class: { active: _vm.selected(cu.userId) },
                                  attrs: { alt: _vm.$t("common.arrow") },
                                },
                                [
                                  _c("img", {
                                    staticClass: "arrow-image",
                                    attrs: {
                                      src: require("@/assets/images/arrowLineDown_white.svg"),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm.selected(cu.userId)
                        ? _c("div", { staticClass: "attendance-user-detail" }, [
                            _c("div", { staticClass: "detail-container" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("Email"),
                              ]),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.selectedUser(cu.userId).email)
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "detail-container" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "camstudy.attendance.recentAttendance"
                                    )
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedUser(cu.userId).attendDate
                                    )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "detail-container" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "camstudy.attendance.recentStudyTime"
                                    )
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedUser(cu.userId)
                                        .recentStudyTime
                                    )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "detail-container" }, [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("camstudy.attendance.totalStudyTime")
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedUser(cu.userId).totalStudyTime
                                    )
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }